import React, { Component } from "react";
import { Loader } from 'react-overlay-loader'
import 'react-overlay-loader/styles.css'

import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import _ from 'lodash'
import 'react-overlay-loader/styles.css'
import requester from '../lib/requester'

class changepass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            newpass: '',
            repass: '',
            loading: false,
            error: [],
            user: []
        }
    }

    componentDidMount = () => {
        // window.localStorage.removeItem('is_token')
        // window.localStorage.removeItem('is_user')
        // if (this.props.location.search === '?unauthorize') {
        //     let error = ['Unauthorized, please login']
        //     this.setState({ error: error })
        // }

        // let user  = JSON.parse(window.localStorage.getItem('is_user'))

        // this.state.username = user.username
        // console.log(this.state.username)
    }

    handleChangePass = (e) => {
        e.preventDefault()
        this.setState({ loading: true })
        let error = []
        // if (this.state.username.length === 0) {
        //     error.push('Username can\'t be blank; ')
     
        // }
        if (this.state.newpass.length === 0) {
            error.push('New Password can\'t be blank; ')
        
        }
        if (this.state.repass.length === 0) {
            error.push('Confirm New Password can\'t be blank; ')
        
        }

        if (this.state.repass != this.state.newpass) {
            error.push('Password did not match: Please try again...')
        
        }

        if (error.length === 0) {
        var on_sure = window.confirm("are you sure to change your password?")
        
            if( on_sure == true )
            {
                var userid = JSON.parse(window.localStorage.getItem('is_user')).user_id
                var pass = this.state.newpass
                var repass = this.state.repass
                // alert (userid)
                // alert (pass)
                // alert (repass)
                    let url = '/api/infostep/v1/user/changepass'
                    let param = { userid: userid, repass: repass }
                    requester.postInfostep(url, param, {
                        success: function (response) {
                                window.location.href = '/login'                   
                        }.bind(this),
                        error: function (e) {
                            let error = 'Failed to change password, please try again'
                            console.log(e)
                            this.setState({ error: [error], loading: false })
                        }.bind(this)
                    })
            }
            else
            {
                error.push("cancel")
            }

        }

       
        else {
            this.setState({ error: error, loading: false })
            return false
        }

     
    }


    handleCancel = (e) => {
        e.preventDefault()
        window.history.back()
        this.setState({ loading: false })
        let error = []
        return false
    }


    handleInputUsername = (e) => {
        this.setState({ username: e.target.value })
    }

    handleInputOldPassword = (e) => {
        this.setState({ password: e.target.value })
    }

    handleInputNewPassword = (e) => {
        this.setState({ newpass: e.target.value })
    }

    handleInputRePassword = (e) => {
        this.setState({ repass: e.target.value })
    }

    showError = () => {
        if (this.state.error.length != 0) {
            return (
                <div className="alert alert-danger" role="alert">
                    <ul>
                        {this.state.error.map((item, index) => {
                            return (<li key={index}>{item}</li>)
                        })}
                    </ul>
                </div>
            )
        }
    }

    render() {
        return (
            <div className="container-fluid container-login100 bg">
                <div className="row">
                    <div className="col-md-4 col-lg-4 col-sm-12 mx-auto mt-5">
                        <div className="card custom-card">
                            <div className="card-body p-5 montserrat">
                                {this.showError()}
                                <div className="row">
                                    <div className="mx-auto"><h4>Change your password here</h4></div>
                                </div>

                                <form >
                                    {/* <div className="form-group">
                        
                                        <input type="text"  disabled autoComplete="off" className="form-control" id="username" placeholder="" value={JSON.parse(window.localStorage.getItem('is_user')).username} />
                                   
                                    </div> */}
                                  
                                    <div className="form-group">
                                       
                                        <input type="password" className="form-control" id="newpass" placeholder="new password" onChange={this.handleInputNewPassword.bind(this)} defaultValue= "" />
                                    </div>

                                    <div className="form-group">
                                       
                                        <input type="password" className="form-control" id="repass" placeholder="confirm new password" onChange={this.handleInputRePassword.bind(this)} defaultValue = ""/>
                                    </div>

                                    <button type = "button" className="btn btn-success btn-block" onClick={ this.handleChangePass.bind(this) }>Change Password</button>&nbsp;
                                    <button type = "button" className="btn btn-danger btn-block" onClick={ this.handleCancel.bind(this) }>Cancel</button>
                                </form>
                            
                               

                            </div>
                        </div>
                    </div>
                </div>
                <Loader fullPage loading={this.state.loading} />
            </div>
        )
    }
}

export default changepass